import { axios } from '@/utils/axios'

// 查询
export async function pnrQuery (params) {
  try {
    return await axios.post('/api/pnrorder/offerQuery', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 提交
export async function pnrSubmit (params) {
  try {
    return await axios.post('/api/pnrorder/placeOrder', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function pointPage (params) {
  try {
    return await axios.post('/api/point/page', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function pointOrder (params) {
  try {
    return await axios.post('/api/point/order', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function pointBalance (params) {
  try {
    return await axios.post('/api/point/balance', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function pointExport (params) {
  try {
    return await axios.post('/api/point/exportExcel', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
